import { MediatorAction } from '@shared/types/action.interface';

export namespace MenuActions {
  export class MenuOpen implements MediatorAction {}
  export class MenuClose implements MediatorAction {}
}
